/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PccAdmissionRecord
 */
export interface PccAdmissionRecord {
    /**
     * 
     */
    exacare_admission_status?: string;
    /**
     * 
     */
    exacare_bed_id?: string;
    /**
     * 
     */
    entered_by?: string;
    /**
     * 
     */
    floor?: string;
    /**
     * 
     */
    unit?: string;
    /**
     * 
     */
    room?: string;
    /**
     * 
     */
    bed?: string;
    /**
     * 
     */
    payer_code?: string;
    /**
     * 
     */
    payer_name?: string;
    /**
     * 
     */
    payer_type?: string;
}

/**
 * Check if a given object implements the PccAdmissionRecord interface.
 */
export function instanceOfPccAdmissionRecord(value: object): value is PccAdmissionRecord {
    return true;
}

export function PccAdmissionRecordFromJSON(json: any): PccAdmissionRecord {
    return PccAdmissionRecordFromJSONTyped(json, false);
}

export function PccAdmissionRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): PccAdmissionRecord {
    if (json == null) {
        return json;
    }
    return {
        
        'exacare_admission_status': json['exacare_admission_status'] == null ? undefined : json['exacare_admission_status'],
        'exacare_bed_id': json['exacare_bed_id'] == null ? undefined : json['exacare_bed_id'],
        'entered_by': json['entered_by'] == null ? undefined : json['entered_by'],
        'floor': json['floor'] == null ? undefined : json['floor'],
        'unit': json['unit'] == null ? undefined : json['unit'],
        'room': json['room'] == null ? undefined : json['room'],
        'bed': json['bed'] == null ? undefined : json['bed'],
        'payer_code': json['payer_code'] == null ? undefined : json['payer_code'],
        'payer_name': json['payer_name'] == null ? undefined : json['payer_name'],
        'payer_type': json['payer_type'] == null ? undefined : json['payer_type'],
    };
}

export function PccAdmissionRecordToJSON(json: any): PccAdmissionRecord {
    return PccAdmissionRecordToJSONTyped(json, false);
}

export function PccAdmissionRecordToJSONTyped(value?: PccAdmissionRecord | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'exacare_admission_status': value['exacare_admission_status'],
        'exacare_bed_id': value['exacare_bed_id'],
        'entered_by': value['entered_by'],
        'floor': value['floor'],
        'unit': value['unit'],
        'room': value['room'],
        'bed': value['bed'],
        'payer_code': value['payer_code'],
        'payer_name': value['payer_name'],
        'payer_type': value['payer_type'],
    };
}

